export var TermsAndConditionsText;
(function (TermsAndConditionsText) {
    TermsAndConditionsText["DEFAULT_TEXT"] = "I have read and agree to the website";
    TermsAndConditionsText["TERMS_AND_CONDITIONS"] = "Terms & Conditions";
})(TermsAndConditionsText || (TermsAndConditionsText = {}));
